import { Conn_Db } from '../models/datapoint/conn_db';
import { CommonEnums } from '../common.enums';

export class Conn_DbsUtil {
    private static instance: Conn_DbsUtil;
    conn_Db: Conn_Db;

    static getInstance() {
        if (!Conn_DbsUtil.instance) {
            Conn_DbsUtil.instance = new Conn_DbsUtil();
        }

        return Conn_DbsUtil.instance;
    }

    /**
    * Conn_DbsUtil is a singleton class, so use Conn_DbsUtil.getInstance() method instead of creating new Conn_DbsUtil().
    */
    private constructor() {
        this.conn_Db = new Conn_Db;
    }

    add(): Conn_Db {

        return null;
    }

    delete(): void {

    }

    setConn_DbDefaults(conn_Db: Conn_Db): void {
        conn_Db.conn_Id = CommonEnums.defaults.LONG_VAL;
        conn_Db.conn_Db_Id = CommonEnums.defaults.LONG_VAL;
        conn_Db.nm = CommonEnums.defaults.STRING_EMPTY;
        conn_Db.description = CommonEnums.defaults.STRING_EMPTY;
        conn_Db.databaseNm = CommonEnums.defaults.STRING_EMPTY;
        conn_Db.dbParamNm = CommonEnums.defaults.STRING_EMPTY;
        conn_Db.schemaNm = CommonEnums.defaults.STRING_EMPTY;
        conn_Db.schemaParamNm = CommonEnums.defaults.STRING_EMPTY;
        conn_Db.stgDb_Flag = CommonEnums.defaults.STRING_VAL_NO
        conn_Db.srt_Order = CommonEnums.defaults.LONG_VAL;
        conn_Db.updateDt = new Date();
        conn_Db.updateBy = CommonEnums.defaults.STRING_EMPTY;
        conn_Db.ref_Id = CommonEnums.defaults.LONG_VAL;
    }

    // copyFrom(conn_Db: Conn_Db, conn_DbTmp: Conn_Db): void {
    //     conn_Db.conn_Id = conn_DbTmp.conn_Id;
    //     conn_Db.conn_Db_Id = conn_DbTmp.conn_Db_Id;
    //     conn_Db.nm = conn_DbTmp.nm;
    //     conn_Db.description = conn_DbTmp.description;
    //     conn_Db.databaseNm = conn_DbTmp.databaseNm;
    //     conn_Db.dbParamNm = conn_DbTmp.dbParamNm;
    //     conn_Db.schemaNm = conn_DbTmp.schemaNm;
    //     conn_Db.schemaParamNm = conn_DbTmp.schemaParamNm;
    //     conn_Db.stgDb_Flag = conn_DbTmp.stgDb_Flag;
    //     conn_Db.srt_Order = conn_DbTmp.srt_Order;
    //     conn_Db.updateDt = conn_DbTmp.updateDt;
    //     conn_Db.updateBy = conn_DbTmp.updateBy;
    //     conn_Db.ref_Id = conn_DbTmp.ref_Id;
    // }

    copyFrom(conn_Dbs: Array<Conn_Db>, conn_DbsTmp: Array<Conn_Db>): void {
        // conn_Dbs.splice(0, conn_Dbs.length);

        // for (var i: number = 0; i < conn_DbsTmp.length; i++) {
        //     conn_Dbs.push(conn_DbsTmp[i]);
        // }

        let conn_Dbs_Map: Map<number, Conn_Db> = new Map();

        let conn_Dbs_Length: number = conn_Dbs.length;
        for (let i: number = 0; i < conn_Dbs_Length; i++) {
            conn_Dbs_Map.set(conn_Dbs[i].conn_Db_Id, conn_Dbs_Length[i]);
        }

        conn_Dbs.splice(0, conn_Dbs.length);

        let conn_DbsTmpLength: number = conn_DbsTmp.length;
        for (let i: number = 0; i < conn_DbsTmpLength; i++) {
            let conn_DbTmp: Conn_Db = conn_DbsTmp[i] as Conn_Db;

            let conn_Db: Conn_Db = conn_Dbs_Map.get(conn_DbTmp.conn_Db_Id);
            if (conn_Db) {
                conn_Db.copyFrom(conn_DbTmp);
            } else {
                conn_Db = Conn_Db.parse(JSON.parse(JSON.stringify(conn_DbTmp)));
            }

            conn_Dbs.push(conn_Db);
        }

    }

    compare(conn_Dbs: Array<Conn_Db>, conn_DbsCopy: Array<Conn_Db>): string {
        let conn_DbsLength: number = conn_Dbs.length;
        let conn_DbsCopyLength: number = conn_DbsCopy.length;

        if (conn_DbsLength != conn_DbsCopyLength) {
            return 'Conn_Dbs length is different.';
        }

        let conn_Db_IdsCopyMap: Map<number, Conn_Db> = new Map();
        for (let i: number = 0; i < conn_DbsCopyLength; i++) {
            let conn_DbCopy: Conn_Db = conn_DbsCopy[i] as Conn_Db;
            conn_Db_IdsCopyMap.set(conn_DbCopy.conn_Db_Id, conn_DbCopy);
        }

        for (let i: number = 0; i < conn_DbsLength; i++) {
            let conn_Db: Conn_Db = conn_Dbs[i] as Conn_Db;

            let conn_DbCopy: Conn_Db = conn_Db_IdsCopyMap.get(conn_Db.conn_Db_Id);
            if (!conn_DbCopy) {
                return conn_Db.conn_Db_Id + ' Conn_Db is found in copy.'
            }

            if (conn_Db.compare(conn_DbCopy) != '') {
                return conn_Db.conn_Db_Id + ' Conn_Db is not equal.'
            }
        }

        return '';
    }
}